import { isPrestataireLibreRole } from './roleUtils';

export interface EspaceCible {
  url: string;
  label: string;
  connecte: boolean;
}

/**
 * Destination "mon espace" d'un utilisateur connecte (mirror exact de la redirection
 * post-login, cf. Login.tsx), ou l'accueil s'il n'est pas connecte.
 *
 * Lit le localStorage directement -> utilisable HORS hook React (pages d'erreur,
 * ErrorBoundary) sans dependre du contexte d'auth.
 */
export function getEspaceCible(): EspaceCible {
  try {
    const raw = localStorage.getItem('user');
    if (!raw) {
      return { url: '/', label: "Retour à l'accueil", connecte: false };
    }
    const role: string = (JSON.parse(raw)?.role ?? '').toString();
    return { url: espaceUrlPourRole(role), label: 'Retour à mon espace', connecte: true };
  } catch {
    return { url: '/', label: "Retour à l'accueil", connecte: false };
  }
}

function espaceUrlPourRole(role: string): string {
  if (isPrestataireLibreRole(role)) return '/profil';
  const estAcheteur =
    role === 'Acheteur' ||
    role === 'Acheteur signataire' ||
    role === 'Acheteur signataire admin' ||
    role.toLowerCase().includes('acheteur');
  return estAcheteur ? '/operations' : '/commandes';
}
